import { isValidString } from '../common/CommonUtilsMethods';

const readCognitoErrorStringField = ({
    error,
    fieldName,
}: {
    readonly error: unknown;
    readonly fieldName: string;
}): string | null => {
    if (typeof error !== 'object' || error === null) {
        return null;
    }

    const errorRecord: Record<string, unknown> = error as Record<string, unknown>;
    const fieldValue: unknown = errorRecord[fieldName];
    if (typeof fieldValue === 'string' && isValidString(fieldValue)) {
        return fieldValue.trim();
    }

    return null;
};

const readCognitoErrorName = (error: unknown): string | null => {
    const errorName: string | null = readCognitoErrorStringField({ error, fieldName: 'name' });
    if (isValidString(errorName)) {
        return errorName;
    }

    return readCognitoErrorStringField({ error, fieldName: '__type' });
};

const isCognitoUserNotConfirmedError = (error: unknown): boolean => {
    const cognitoErrorName: string | null = readCognitoErrorName(error);
    if (cognitoErrorName === 'UserNotConfirmedException') {
        return true;
    }

    if (typeof error !== 'object' || error === null) {
        return false;
    }

    const errorRecord: Record<string, unknown> = error as Record<string, unknown>;
    const underlyingError: unknown = errorRecord.underlyingError;
    if (underlyingError !== undefined) {
        return isCognitoUserNotConfirmedError(underlyingError);
    }

    return false;
};

export { isCognitoUserNotConfirmedError };
